var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slide"},[_c('el-carousel',{attrs:{"interval":4000,"height":"500px","trigger":"click","width":"100%"}},_vm._l((_vm.options),function(item,index){return _c('el-carousel-item',{key:index},[_c('img',{attrs:{"src":item.src}})])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }